/* eslint-disable no-console */
import React, { useState } from 'react'

import * as S from './styles'

type ReceiptModalProps = {
  onGenerateNonTax: () => void;
}

const ReceiptModal = ({ onGenerateNonTax }: ReceiptModalProps) => {
  const [loading, setLoading] = useState(false)

  const handleSubmit = async () => {
    try {
      setLoading(true)
      await onGenerateNonTax()
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <S.Container>
      <h2>Venda finalizada com sucesso!</h2>

      <S.ButtonWrapper>
        <S.Button onClick={handleSubmit}>
          {
            loading ? 'Carregando...' : 'Imprimir cupom'
          }
        </S.Button>
        {/* <S.Button>Emitir NFC-e</S.Button> */}
      </S.ButtonWrapper>
    </S.Container>
  )
}

export default ReceiptModal
